import moment from 'moment'
import firedux from '../firedux'
import {dispatch} from '../store'
import {fromJS} from 'immutable'

import {
  MESSAGES_ENDPOINT
} from '../../config/constants'

import setPreviousMessages from '../actions/set_previous_messages'
import getUser from './user'

const getUsersForMessages = (messages) => {
  fromJS(messages).forEach((message) => getUser(message.get('from')))
}

const onReceivePreviousMessages = (containerId, startTime, snapshot) => {
  if (!snapshot.exists()) return startTime

  const messages = snapshot.val()

  dispatch(setPreviousMessages(messages, containerId))
  getUsersForMessages(messages)

  return startTime
}

export default (containerId, limit = null, startTime = moment().valueOf()) => {
  if (!containerId) return

  startTime = startTime - 1 // not to get first message of previous batch

  const ENDPOINT = `${MESSAGES_ENDPOINT}/${containerId}`

  let ref = firedux.ref.child(ENDPOINT).orderByChild('time').endAt(startTime)
  if (limit) ref = ref.limitToLast(limit)

  return ref.once('value').then(onReceivePreviousMessages.bind(null, containerId, startTime))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/getters/previous_messages.js
 **/